import React, { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react';
import TaskOffCanvas from '../../../common/OffCanvas';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import EmployeeAddUpdate from "./EmployeeAddUpdate";
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import { ShowSwal, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { getPageSizeArray, getFilteredList, paginationStyles, dropDownSelectionStyles, dropDownActiveInActive } from '../../../common/timeLiveFunction';
import { setItemStatus, getValueFromResource} from '../../../common/timeLiveFunction';
import PageSizeSelect from '../../../common/PageSizeSelect';
import clsx from 'clsx';
import {
    getEmployeesList, deleteAccountEmployeeAsync, updateIsDisabledAsync,
    updatePagination, updateSearchPagination, updateAccountEmployeeId, updateIsCanvasLoading, updateIsLoading,
    checkedState, unCheckedState, checkedAllState, unCheckedAllState, deleteAllSelectedEmployeeAsync,
    setSearchValue, setPageSize, ResendVerificationEmailAsync, resetSelectedRecordObjectInState, updateSorting,
    updateCallEdit,updateIsDisabledValue,updateIsDisabledBulkAsync
} from "./employeeSlice";
import { useTranslation } from "react-i18next";
import { getParentChildPagePermissionsAsync, getPagePermissionsAsync, UpdateEmployeePermissions } from '../../../common/GlobalSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from 'react-bootstrap'
import { useDebounce } from '../../../_metronic/helpers';
import Select, { StylesConfig } from 'react-select';
import Loader from '../../../common/Loader';
import * as Sentry from '@sentry/react'
import { width } from '@mui/system';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import fetchAPI from '../../../common/fetchAPI';
import EmployeeFilters from './EmployeeFilters';

const Employee = () => {
    const [menuItems, setMenuItems] = useState([]);

    const { isReload, currentPage, employeeList, pageSize, search, totalItems, isShowGrid, isLoading, start, columnIndex, direction, recordsFiltered, accountemployeeid, sortColumn, sortOrder,
         IsDisabledValue, filterEmployeeName, filterEmailAddress,filterRoleId,filterLocationId,filterDepartmentId, filterStatus } = useAppSelector((state) => state.employee);
    const { pageId, menuList, IsList, IsAdd, IsEdit, manageTerminologyList, IsDelete, sessionAccountEmployeeId, enablePasswordComplexity, maxMenuHeight, accountBaseCurrencyId, showCostCenterInTimesheetBy} = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
    const [isLoadEmployeeFields, setLoadEmployeeFields] = useState(false);
    
   
    const [isFilterCanvasOpen, setIsFilterCanvasOpen] = useState(false);
    const [canvasTitle, setCanvasTitle] = useState("");
    const [canvasWidth, setCanvasWidth] = useState("700px");

    let IsLicenseExpired = localStorage.getItem('IsLicenseExpired');
    const AccountId = localStorage.getItem('accountId');
    const isAllChecked = useSelector((state: RootState) => state.employee.isAllChecked);
    const [isShowAddEmployee, setIsShowAddEmployee]=useState(false);

    const getFilterParams = (overrideParams: any = {}) => {
        return {
            currentPage: currentPage,
            pageSize: pageSize,
            start: start,
            order: columnIndex,
            orderDir: direction,
            search: search || " ",           
            EmployeeName: filterEmployeeName || "",
            EmailAddress: filterEmailAddress || "",
            RoleId: filterRoleId,
            LocationId: filterLocationId,
            DepartmentId: filterDepartmentId,
            IsDisabledValue: filterStatus !== undefined ? Number(filterStatus) : 0, 
            ...overrideParams 
        };
    };

    const getLicenseActivation=async()=>{
        try {
            const response = await fetchAPI('api/v2/LicenseActivation/PageLoad', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            if(response?.status === 200){
                const json = await response.json();
                const allowedEmployee = json?.rowscount >= json?.numberOfUsersAllowed;
                setIsShowAddEmployee(allowedEmployee);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
        getLicenseActivation();
    },[isReload])
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
                dispatch(UpdateEmployeePermissions({
                    IsEmployeeList: res.payload.IsList,
                    IsEmployeeAdd: res.payload.IsAdd,
                    IsEmployeeEdit: res.payload.IsEdit,
                    IsEmployeeDelete: res.payload.IsDelete,
                }));          
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }           
        };
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    useEffect(() => {
        if (isReload) {
            dispatch(getEmployeesList(getFilterParams()));
        }
    }, [isReload])

    useEffect(() => {
         dispatch(getEmployeesList(getFilterParams()))
        .unwrap()
            .then((originalPromiseResult) => {
                setIsFirstTimeLoad(false);
            })
            .catch((rejectedValueOrSerializedError) => {
                Sentry.captureException(rejectedValueOrSerializedError);
            })
    }, [dispatch])

 const handlePageChange = (pageNumber: any) => {
        const newStart = (pageNumber - 1) * Number(pageSize);
        
        dispatch(getEmployeesList(getFilterParams({ 
            currentPage: pageNumber, 
            start: newStart 
        })));
    }

    const onUnverifiedClick = (AccountEmployeeId: number) => {
        dispatch(ResendVerificationEmailAsync(AccountEmployeeId))
            .unwrap()
            .then((originalPromiseResult) => {
                ShowSwal('Email', 'Email resent successfully.', 'success');
            })
            .catch((rejectedValueOrSerializedError) => {
                Sentry.captureException(rejectedValueOrSerializedError);
            })
    }

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    const filteredList = employeeList.filter(user => user.isSelected === 1 && user.AccountEmployeeId !== sessionAccountEmployeeId);
                    dispatch(deleteAllSelectedEmployeeAsync(filteredList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Employee Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            Sentry.captureException(rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                Sentry.captureException(error)
            });
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState(sessionAccountEmployeeId));
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const deleteAccountEmployeeById = (id: number) => {
        if (sessionAccountEmployeeId === id) {
            ShowSwal('Delete', 'Administrator Account cannot be disabled/deleted Please assign Administrator role to any other employee then retry.', 'error');
            return false
        }
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountEmployeeAsync(id)).then((result) => {
                        Number(result.payload.Id) > 0 ?
                            ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right") :
                            ShowToast('error', result.payload.ResponseMessage, "error", "toast-top-right");
                    }).catch((error) => {
                        Sentry.captureException(error);
                    });
                }
            })
            .catch((error) => {
                Sentry.captureException(error);
            });
    }

    const addAccountEmployee = () => {
        dispatch(resetSelectedRecordObjectInState());
        dispatch(updateAccountEmployeeId(0));
        setIsFilterCanvasOpen(false);
        setLoadEmployeeFields(true);
        setCanvasTitle(getValueFromResource('Add Employee', dispatch, t));
        setCanvasWidth("700px");
    }

    const editAccountEmployeeById = (id: number) => {
        dispatch(resetSelectedRecordObjectInState());
        dispatch(updateIsCanvasLoading(true));
        dispatch(updateAccountEmployeeId(id));
        setIsFilterCanvasOpen(false);
        setLoadEmployeeFields(true);
        setCanvasTitle(getValueFromResource('Update Employee', dispatch, t));
        setCanvasWidth("700px");
    }

    const handleIsDisabledChange = (e: any, accountClient: any) => {
        const { checked } = e.target;
        const foundIndex = employeeList.findIndex((item: any) => item.AccountEmployeeId === accountClient.AccountEmployeeId);
        if (foundIndex !== -1) {
            const foundItem = employeeList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            dispatch(updateIsDisabledAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Employee Disabled Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    Sentry.captureException(rejectedValueOrSerializedError);
                })
        }
    }

    const navigateToEmployeeSummary = (obj: any) => {
        localStorage.setItem('objEmployee', JSON.stringify(obj));
        navigate(`/employeesummary/${obj.AccountEmployeeId}`);
    }

    const debouncedSearchTerm = useDebounce(search, 500);
    useEffect(() => {
        if (!isFirstTimeLoad) {
            dispatch(getEmployeesList(getFilterParams({ 
                currentPage: 1, 
                start: 0, 
                search: debouncedSearchTerm 
            })));
        }
    }, [debouncedSearchTerm]);



    const handleSearch = (event: any) => {
        const { value } = event.target;
        dispatch(updateSearchPagination(event.target.value));
        dispatch(setSearchValue(value))
    }


  const handlePageSizeChange = (event: any) => {
        const { value } = event;
        const updatedPageSize = Number(value);        
        dispatch(setPageSize(updatedPageSize));
        dispatch(getEmployeesList(getFilterParams({ 
            currentPage: 1, 
            pageSize: updatedPageSize, 
            start: 0 
        })));
    }

    const navigateToAudit = (AccountEmployeeId: any) => {
        const obj = {
            Id: AccountEmployeeId,
            TableName: 'AccountEmployee',
            Title: getValueFromResource("Employee Audit", dispatch, t)
        }
        navigate(`/accountaudit/${AccountEmployeeId}`, { state: { obj } })
    }
    
    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "start": 0,
            "pageSize": pageSize,
            "currentPage": 1
        }
        dispatch(updateSorting(objects));
        dispatch(getEmployeesList(getFilterParams({ 
            currentPage: 1, 
            start: 0, 
            order: sortColumn, 
            orderDir: sortOrder 
        })));
    }

    const handleBulkStatusUpdate = async (isDisabled: number) => {
        const filteredList = employeeList.filter(
            user => user.isSelected === 1 && user.AccountEmployeeId !== sessionAccountEmployeeId
        );
        const count = filteredList.length;

        if (count === 0) {
            ShowToast('Warning', 'No records selected', "warning", "toast-top-right");
            return;
        }

        const recordText = count === 1 ? "record" : "records";

        ShowSwalWithConfirmation(
            `You are updating <b>${count}</b> ${recordText} to <b>${isDisabled === 1 ? 'Inactive' : 'Active'}</b>. Proceed?`,
            ""
        )
            .then(async (result: any) => {
                if (!result) return;
                try {
                    const payload = filteredList.map((item: any) => ({
                        AccountId,
                        AccountEmployeeId: item.AccountEmployeeId,
                        IsDisabled: isDisabled
                    }));

                    dispatch(updateIsLoading(true));
                    const updateResult = await dispatch(updateIsDisabledBulkAsync(payload)).unwrap();

                    if (updateResult?.StatusCode === '200') {
                       await dispatch(getEmployeesList(getFilterParams()));
                        ShowToast(
                            'Success',
                            `Employees ${isDisabled === 1 ? 'Inactive' : 'Active'} successfully`,
                            "success",
                            "toast-top-right"
                        );
                    } else {
                        ShowToast(
                            'Error',
                            updateResult?.ResponseMessage || 'Operation failed',
                            "error",
                            "toast-top-right"
                        );
                    }
                    dispatch(unCheckedAllState());                    

                } catch (error) {
                    console.error('Bulk status update error:', error);
                    Sentry.captureException(error);
                    ShowToast('Error', 'Failed to update employee status', "error", "toast-top-right");
                }
            })
            .catch((error: any) => {
                console.error(error);
                Sentry.captureException(error);
            });
    };
    
    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading">
                        {getValueFromResource('Employees',dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={(e: any) => handleSearch(e)}
                                placeholder={getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='card-toolbar' style={{ justifyContent: 'right' }}>
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <div className="d-flex align-items-center">
                                <PageSizeSelect onChange={handlePageSizeChange} />
                            </div>

                            {(IsLicenseExpired === "false" && employeeList.length > 0) && (
                                <>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <div>
                                        <CustomPagination
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                            start={(currentPage - 1) * Number(pageSize)}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        />
                                    </div>
                                </>
                            )}
                            
                            <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ display: employeeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}></div>
                                                                                    
                           
                            <button 
                                id="kt_OffCanvas"
                                type="button"
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                onClick={() => {
                                    setLoadEmployeeFields(false);
                                    setIsFilterCanvasOpen(true);
                                    setCanvasTitle(getValueFromResource("Filters", dispatch, t));
                                    setCanvasWidth("500px");
                                }}
                                style={{ display: employeeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                <i className="bi bi-filter fs-3 iconColor"></i>
                            </button>

                            {(IsAdd || (IsDelete && employeeList.some((item: any) => item.isSelected === 1))) ? (
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            ) : null}

                            {(IsAdd && !isShowAddEmployee) &&
                                <button id="kt_OffCanvas" type="button"
                                    className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                    onClick={() => { 
                                        dispatch(updateCallEdit(false));
                                        addAccountEmployee();
                                    }}
                                    disabled={IsLicenseExpired === "true" ? true : false}
                                    style={{ marginRight: '2px', display: employeeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                                >
                                    {getValueFromResource('Add Employee',dispatch, t)}
                                </button>
                            }

                            {IsDelete &&
                                <>
                                    <div className="text-muted me-5" style={{ marginRight: '2px', display: employeeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                        <span className="me-2" data-kt-user-table-select="selected_count">{employeeList.filter((item: any) => item.isSelected === 1).length}</span> 
                                        {getValueFromResource('Selected',dispatch, t)}
                                    </div>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ marginRight: '2px', display: employeeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}></div>
                                    <div className="btn-group" style={{ marginRight: '2px', display: employeeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false">
                                            {getValueFromResource('Bulk Action', dispatch, t)}
                                            <i className="fa fa-angle-down ms-1"></i>
                                        </button>
                                        <ul className="dropdown-menu menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-135px" role="menu">
                                            <div className='menu-hover-bg-sec'>
                                                <Dropdown.Item className="menu-item me-lg-0" onClick={() => handleBulkStatusUpdate(0)}>
                                                    <span className="menu-title custom-menu-fontsize" style={{ marginLeft: 6 }}>
                                                        {getValueFromResource('Active', dispatch, t)}
                                                    </span>
                                                </Dropdown.Item>
                                                <Dropdown.Item className="menu-item me-lg-0" onClick={() => handleBulkStatusUpdate(1)}>
                                                    <span className="menu-title custom-menu-fontsize" style={{ marginLeft: 6 }}>
                                                        {getValueFromResource('InActive', dispatch, t)}
                                                    </span>
                                                </Dropdown.Item>
                                                <Dropdown.Item className="menu-item me-lg-0" onClick={onDeleteSelectedClick}>
                                                    <span className="menu-title custom-menu-fontsize" style={{ marginLeft: 6 }}>
                                                        {getValueFromResource('Delete', dispatch, t)}
                                                    </span>
                                                </Dropdown.Item>
                                            </div>
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className='card-Report-body py-3'>
                    <div className='table-responsive'>
                        <table className="table table-row-bordered align-middle gs-1 gy-1 gx-1">
                            <thead>
                                <tr className="thHeading align-middle">
                                    {IsDelete &&
                                        <th className='w-25px'>
                                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    value='1'
                                                    onChange={handleSelectAllChange}
                                                    checked={isAllChecked}
                                                />
                                            </div>
                                        </th>
                                    }
                                    <th style={{ width: '5%' }}></th>
                                    <th style={{ width: '10%' }}>
                                        {getValueFromResource('Active / Inactive',dispatch, t)}
                                        {sortColumn === '1' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '10%' }}>
                                        {getValueFromResource('Code',dispatch, t)}
                                        {sortColumn === '3' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}>
                                        {getValueFromResource('Name',dispatch, t)}
                                        {sortColumn === '4' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}>
                                        {getValueFromResource('Email Address',dispatch, t)}
                                        {sortColumn === '5' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                     <th style={{ width: '10%' }}>
                                        {getValueFromResource('Role',dispatch, t)}
                                        {sortColumn === '6' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}>
                                        {getValueFromResource('Location',dispatch, t)}
                                        {sortColumn === '6' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th style={{ width: '15%' }}>
                                        {getValueFromResource('Department',dispatch, t)}
                                        {sortColumn === '7' ?
                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "7") }}>
                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "7") }}>
                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                            </span>
                                            :
                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "7") }}>
                                                <i className="bi bi-sort-up fs-6 headerSortIcon"></i>
                                            </span>
                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "7") }}>
                                                    <i className="bi bi-sort-down fs-6 headerSortIcon"></i>
                                                </span>
                                            </>}
                                    </th>
                                    <th className='min-w-100px text-end'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {employeeList.length > 0 && employeeList.map((item : any) => {
                                    return (
                                        <tr key={item.AccountEmployeeId}>
                                            {IsDelete &&
                                                <td>
                                                    {item.AccountEmployeeId !== sessionAccountEmployeeId &&
                                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input widget-9-check"
                                                                checked={item.isSelected == 0 ? false : true}
                                                                onChange={(e) => { handleCheckboxChange(e, item.AccountEmployeeId) }}
                                                                disabled={item.AccountEmployeeId === sessionAccountEmployeeId}
                                                            />
                                                        </div>
                                                    }
                                                </td>
                                            }
                                            <td>
                                                <span style={{ color: '#7b8ba6', fontSize: '11px' }}>
                                                    <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                                        <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                                            <div className='symbol symbol-circle symbol-35px'>
                                                                {item.IsShowEmployeeProfilePicture && item.ProfileUrl ? (
                                                                    <img
                                                                        src={item.ProfileUrl}
                                                                        style={{
                                                                            borderRadius: "50%",
                                                                            width: "35px",
                                                                            height: "35px",
                                                                        }}
                                                                        alt="Employee Profile"
                                                                    />
                                                                ) : (
                                                                    <div className='symbol-label fw-bold text-inverse-warning'
                                                                        style={{ backgroundColor: item.ProfileColor != null ? item.ProfileColor : '#512DA8' }}
                                                                    >
                                                                        {item.Abbrevation}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                            </td>
                                            <td>
                                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(item.IsDisabled === false ? "Active" : "InActive"))}>
                                                    {item.IsDisabled === false ? "Active" : "InActive"}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="d-block">
                                                    {item.EmployeeCode}
                                                </span>
                                            </td>
                                            <td>
                                                <a className='text-dark fw-bold d-block cursor'
                                                    onClick={() => {
                                                        navigateToEmployeeSummary({
                                                            "AccountEmployeeId": item.AccountEmployeeId,
                                                            "IsSummaryFrom": 'View'
                                                        });
                                                    }}
                                                >
                                                    {item.EmployeeName}
                                                </a>
                                            </td>
                                            <td>
                                                <span className="text-muted d-block fs-7 mb-1">{item.EMailAddress}</span>
                                                {item.IsEmailVerified === false ?                                                   
                                                    <span
                                                        data-toggle="tooltip"
                                                        data-theme="dark"
                                                        title="Click To Resend Verification Email"
                                                        className="symbol-hover badge badge-light-warning fs-7 mb-1"
                                                        onClick={() => { onUnverifiedClick(item.AccountEmployeeId) }}
                                                        style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7', cursor: 'pointer' }}
                                                    >
                                                        {getValueFromResource('Unverified', dispatch, t)}
                                                    </span>
                                                            :
                                                    <span className="symbol-hover badge badge-light-success fs-7 mb-1"
                                                     style={{ fontSize: 'x-small', fontWeight: '500', lineHeight: '.7' ,cursor: 'pointer'}}>
                                                        {getValueFromResource('Verified',dispatch, t)}
                                                    </span>}
                                            </td>
                                            <td>
                                                <span className="d-block">
                                                    {item.Role}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="d-block">
                                                    {item.AccountLocation}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="d-block">
                                                    {item.DepartmentName}
                                                </span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content={getValueFromResource('More',dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-three-dots fs-7 " ></i>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu
                                                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                        {IsEdit && <>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => { 
                                                                    editAccountEmployeeById(item.AccountEmployeeId) 
                                                                    dispatch(updateCallEdit(true))
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign"></i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        </>}
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item className="menu-item me-lg-0 ">
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-file-earmark-text fs-4 iconColor "></i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize"
                                                                    onClick={() => {
                                                                        navigateToEmployeeSummary({
                                                                            "AccountEmployeeId": item.AccountEmployeeId,
                                                                            "IsSummaryFrom": 'View'
                                                                        });
                                                                    }}
                                                                >
                                                                    {getValueFromResource('View Employee',dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item className="menu-item me-lg-0 ">
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-people fs-6"></i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize"
                                                                    onClick={() => {
                                                                        navigate(`/accountbillingrate/${item.AccountEmployeeId}`, {
                                                                            state: {
                                                                                "AccountEmployeeId": item.AccountEmployeeId,
                                                                                "SystemBillingRateTypeId": 1
                                                                            }
                                                                        })
                                                                    }}
                                                                >
                                                                    {getValueFromResource('Rate History',dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigateToAudit(item.AccountEmployeeId)}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-receipt fs-6 iconColor"></i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Audit',dispatch, t)}
                                                                </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                        {showCostCenterInTimesheetBy !== null && showCostCenterInTimesheetBy.toLowerCase() === "employee" && <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item className="menu-item me-lg-0 ">
                                                                    <span className="menu-icon custom-menu mb-2">
                                                                        <i className="bi bi-people fs-6"></i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize"
                                                                        onClick={() => {
                                                                            navigateToEmployeeSummary({
                                                                                "AccountEmployeeId": item.AccountEmployeeId,
                                                                                "IsSummaryFrom": 'CostCenter'
                                                                            });
                                                                        }}
                                                                    >
                                                                        {getValueFromResource('Cost Center',dispatch, t)}
                                                                    </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>}
                                                        {IsDelete &&
                                                            <>
                                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                                <div className='menu-hover-bg-danger'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0 "
                                                                        onClick={() => { deleteAccountEmployeeById(Number(item.AccountEmployeeId)) }}
                                                                    >
                                                                        <span className="menu-icon  custom-menu mb-2">
                                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" ></i>
                                                                        </span>
                                                                        <span className="menu-title delete-menu custom-menu-fontsize">
                                                                            {getValueFromResource('Delete',dispatch, t)}
                                                                        </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                            </>
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {employeeList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {getValueFromResource('No Record Found',dispatch, t)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            
           
            {canvasTitle && (
                <TaskOffCanvas
                    obj={{
                        "name": canvasTitle,
                        "width": canvasWidth,
                        "componentName": isFilterCanvasOpen ? (
                            <EmployeeFilters t={t} />
                        ) : isLoadEmployeeFields ? (
                            <EmployeeAddUpdate 
                                enablePasswordComplexity={enablePasswordComplexity} 
                                IsAdd={IsAdd} 
                                IsLicenseExpired={IsLicenseExpired} 
                            />
                        ) : null
                    }}
                />
            )}
        </>
    )
}

export default Employee;